import SolicitacaoPagamentoEstrangeiroPj from './componentes/SolicitacaoPagamentoEstrangeiroPj.vue';
import SolicitacaoPagamentoEstrangeiroPjLista from './componentes/SolicitacaoPagamentoEstrangeiroPjLista.vue';
import SolicitacaoPagamentoEstrangeiroPjForm from './componentes/SolicitacaoPagamentoEstrangeiroPjForm.vue';
import SolicitacaoPagamentoEstrangeiroPjRelatorio from './componentes/SolicitacaoPagamentoEstrangeiroPjRelatorio.vue';

export default {
  path: '/solicitacao-pagamento-estrangeiro-pj',
  component: SolicitacaoPagamentoEstrangeiroPj,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoPagamentoEstrangeiroPjLista,
      name: 'solicitacao-pagamento-estrangeiro-pj',
    },
    {
      path: 'nova',
      component: SolicitacaoPagamentoEstrangeiroPjForm,
      name: 'solicitacao-pagamento-estrangeiro-pj.nova',
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoPagamentoEstrangeiroPjRelatorio,
      name: 'solicitacao-pagamento-estrangeiro-pj.relatorio'
    },
    {
      path: ':idCript',
      component: SolicitacaoPagamentoEstrangeiroPjForm,
      name: 'solicitacao-pagamento-estrangeiro-pj.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-pagamento/estrangeiro-pj/rotas.js